import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_PROVIDER_RESET = 'PUT_PROVIDER_RESET';
export const PUT_PROVIDER_LOADING = 'PUT_PROVIDER_LOADING';
export const PUT_PROVIDER_SUCCESS = 'PUT_PROVIDER_SUCCESS';
export const PUT_PROVIDER_REJECT = 'PUT_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const putProviderReset = () => ({ type: PUT_PROVIDER_RESET });
export const putProviderLoading = () => ({ type: PUT_PROVIDER_LOADING });
export const putProviderSuccess = (payload) => ({ type: PUT_PROVIDER_SUCCESS, payload });
export const putProviderReject = (payload) => ({ type: PUT_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putProviderRequest = async (data, getState) => {

    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Providers/web/UpdateProviders`, options);
};


